module.exports = __webpack_public_path__ + "media/images/shared/cbs-551b291ed13ea0f8900c431cf4ec2f8b0e2682673ab60cb00fe59fa8520a99cd.png";